import { useEffect, useState } from "react";
import styled from "styled-components";
import COLORS from "components/atoms/colors";
import imageDefalut from "assets/images/common/logo-light-gray.svg";

interface Props {
  src: string;
  className?: string;
}

// 이미지 조회 컴포넌트
const Image = ({ src, className }: Props) => {
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    setImageError(!src);
  }, [src]);

  return (
    <>
      {imageError ? (
        <ImageWrap>
          <img src={imageDefalut} alt="" width={98} />
        </ImageWrap>
      ) : (
        <img
          src={src}
          alt=""
          onError={() => setImageError(true)}
          className={`w-full h-full ${className}`}
        />
      )}
    </>
  );
};

const ImageWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background-color: ${COLORS.white["60%"]};
`;

export default Image;
